import { useTranslation } from "react-i18next";
import { FC, useCallback, useMemo } from "react";
import { TransactionMethods, TransactionOperation } from "@finbackoffice/fe-core";
import { DropdownOption, formatTransactionMethodId } from "@finbackoffice/site-core";
import { TransactionSource } from "@finbackoffice/enums";
import DateRangePicker, {
    DateRangePickerReturnObj,
} from "components/base/date-range-picker/DateRangePicker";
import { useDate } from "hooks";
import UniversalDeviceDropdown from "components/base/universal-device-dropdown/UniversalDeviceDropdown";
import { ITransactionsFilterState } from "../AccountTransactions";
import styles from "./transactions-tools.module.sass";

interface IProps {
    filter: ITransactionsFilterState;
    onChange: (val: ITransactionsFilterState) => void;
}

const TransactionsTools: FC<IProps> = ({ onChange, filter }) => {
    const { t } = useTranslation();
    const { endOfDay } = useDate();
    // const firstDayOfThisMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    // const lastDayOfThisMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    const updateOperationFilter = useCallback(
        (val: string) => {
            onChange({ ...filter, operation: val });
        },
        [filter, onChange],
    );

    const onRangeChangeHandler = (obj: DateRangePickerReturnObj) => {
        const range = { ...obj };

        if (range.to) {
            range.to = endOfDay(new Date(range.to));
        }
        onChange({ ...filter, ...range });
    };

    const operations = useMemo((): DropdownOption[] => {
        const result: DropdownOption[] = [];

        TransactionMethods.forEach(
            (method: { source: TransactionSource; operation: TransactionOperation[] }) => {
                result.push({
                    value: `${method.source}-${method.operation.join(",")}`,
                    label: t(
                        `transaction_${formatTransactionMethodId(
                            `${method.source}-${method.operation[0]}`,
                        ).replace("-", "_")}`,
                    ),
                });
            },
        );

        result.unshift({ value: "", label: t("transaction_all") });

        return result;
    }, [t]);

    return (
        <div className={styles.tools}>
            <UniversalDeviceDropdown
                name="operation"
                options={operations}
                value={filter.operation}
                onChange={updateOperationFilter}
                wrapperClassname={styles.dropdown}
                variantStyle="gradient"
            />

            <DateRangePicker
                range={{ from: filter.from, to: filter.to }}
                dateFormat="MMM/dd/yy"
                onChange={onRangeChangeHandler}
            />
        </div>
    );
};

export default TransactionsTools;
